import request from '@/utils/request';
class ReportService{
    static savereport(data){
        return request({
            url:'/report/savereport',
            method:'post',
            data
        })
    }
    
}

export default ReportService